<template>
  <section class="body--main">
    <div class="container-fluid">
      <div class="container">
        <nav aria-label="breadcrumb" class="hide__on_mobile">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Accueil</li>
            <li class="breadcrumb-item">Assurance multirisque habitation</li>
            <li class="breadcrumb-item active" aria-current="page">
              Assurance multirisque habitation “APEFA”
            </li>
          </ol>
        </nav>
        <div class="page__header--info">
          <div class="page__header--info__text">
            Souscrire à Assurance multirisque habitation
          </div>
        </div>

        <div class="body__form--subscription">
          <div class="subscription__section">
            <div class="hide__subscription-section">
              <div class="card">
                <div class="card-body">
                  <div class="step__voyage">
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 1 ? 'custom__badge--active' : ''"
                      >
                        1
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 1 ? 'badge__text--active--active' : ''"
                      >
                        Informations
                      </div>
                    </div>
                    <hr />
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 2 ? 'custom__badge--active' : ''"
                      >
                        2
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 2 ? 'badge__text--active--active' : ''"
                      >
                        Fichiers joints
                      </div>
                    </div>
                    <hr />
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 3 ? 'custom__badge--active' : ''"
                      >
                        2
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 3 ? 'badge__text--active--active' : ''"
                      >
                        Résultat
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="card">
                <div class="card-body">
                  <div class="custom__badge-section d-md-none">
                    <div
                      class="custom__badge_default"
                      :class="step === 1 ? 'custom__badge--active' : ''"
                    >
                      1
                    </div>
                    <div
                      class="custom__badge_default"
                      :class="step === 2 ? 'custom__badge--active' : ''"
                    >
                      2
                    </div>
                    <div
                      class="custom__badge_default"
                      :class="step === 3 ? 'custom__badge--active' : ''"
                    >
                      3
                    </div>
                  </div>
                  <h4 class="mb-4">{{ titleStep() }}</h4>
                  <div v-if="step === 1">
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Activité/Profession</label>
                          <input
                            v-model="form.data.activity"
                            type="text"
                            class="form-control"
                          />
                          <div v-if="errors.activity" style="color: red">
                            {{ errors.activity[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row mt-2">
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>Valeur du contenu</label>
                          <input
                            v-model="form.data.content_value"
                            type="number"
                            min="0"
                            class="form-control"
                          />
                          <div v-if="errors.content_value" style="color: red">
                            {{ errors.content_value[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>Valeur du bâtiment</label>
                          <input
                            v-model="form.data.building_value"
                            type="number"
                            min="0"
                            class="form-control"
                          />
                          <div v-if="errors.building_value" style="color: red">
                            {{ errors.building_value[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <label>Etes-vous propriétaire du bâtiment ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              v-model="form.data.owner_of_the_building"
                              :value="true"
                              type="radio"
                              class="form-check-input"
                              name="owner"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              v-model="form.data.owner_of_the_building"
                              :value="false"
                              type="radio"
                              class="form-check-input"
                              name="owner"
                            />Non
                          </label>
                        </div>
                        <div
                          v-if="errors.owner_of_the_building"
                          style="color: red"
                        >
                          {{ errors.owner_of_the_building[0] }}
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <label>Etes-vous locataire du bâtiment ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              v-model="form.data.building_tenant"
                              :value="true"
                              type="radio"
                              class="form-check-input"
                              name="tenant"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              v-model="form.data.building_tenant"
                              :value="false"
                              type="radio"
                              class="form-check-input"
                              name="tenant"
                            />Non
                          </label>
                        </div>
                        <div v-if="errors.building_tenant" style="color: red">
                          {{ errors.building_tenant[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="form-row mt-2">
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>Quel est la surface habitable (en m2) ?</label>
                          <input
                            v-model="form.data.living_space"
                            type="text"
                            class="form-control"
                          />
                          <div v-if="errors.living_space" style="color: red">
                            {{ errors.living_space[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>Quelle est l'année de construction ?</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <svg
                                  width="18"
                                  height="19"
                                  viewBox="0 0 18 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0)">
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.75 3.82251C3.33579 3.82251 3 4.1583 3 4.57251V15.0725C3 15.4867 3.33579 15.8225 3.75 15.8225H14.25C14.6642 15.8225 15 15.4867 15 15.0725V4.57251C15 4.1583 14.6642 3.82251 14.25 3.82251H3.75ZM1.5 4.57251C1.5 3.32987 2.50736 2.32251 3.75 2.32251H14.25C15.4926 2.32251 16.5 3.32987 16.5 4.57251V15.0725C16.5 16.3152 15.4926 17.3225 14.25 17.3225H3.75C2.50736 17.3225 1.5 16.3152 1.5 15.0725V4.57251Z"
                                      fill="#6E6B7B"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M12 0.82251C12.4142 0.82251 12.75 1.1583 12.75 1.57251V4.57251C12.75 4.98672 12.4142 5.32251 12 5.32251C11.5858 5.32251 11.25 4.98672 11.25 4.57251V1.57251C11.25 1.1583 11.5858 0.82251 12 0.82251Z"
                                      fill="#6E6B7B"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M6 0.82251C6.41421 0.82251 6.75 1.1583 6.75 1.57251V4.57251C6.75 4.98672 6.41421 5.32251 6 5.32251C5.58579 5.32251 5.25 4.98672 5.25 4.57251V1.57251C5.25 1.1583 5.58579 0.82251 6 0.82251Z"
                                      fill="#6E6B7B"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M1.5 7.57251C1.5 7.1583 1.83579 6.82251 2.25 6.82251H15.75C16.1642 6.82251 16.5 7.1583 16.5 7.57251C16.5 7.98672 16.1642 8.32251 15.75 8.32251H2.25C1.83579 8.32251 1.5 7.98672 1.5 7.57251Z"
                                      fill="#6E6B7B"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0">
                                      <rect
                                        width="18"
                                        height="18"
                                        fill="white"
                                        transform="translate(0 0.0725098)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                            </div>
                            <input
                              v-model="
                                form.data.year_of_construction_of_the_building
                              "
                              class="form-control"
                              type="year"
                            />
                            <div
                              v-if="errors.year_of_construction_of_the_building"
                              style="color: red"
                            >
                              {{
                                errors.year_of_construction_of_the_building[0]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label
                            >Prière faire une brève description de votre
                            bâtiment (niveaux, matériaux, types de
                            construction)</label
                          >
                          <textarea
                            v-model="form.data.description_of_the_building"
                            type="text"
                            class="form-control"
                          ></textarea>
                          <div
                            v-if="errors.description_of_the_building"
                            style="color: red"
                          >
                            {{ errors.description_of_the_building[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7 col-12">
                        <label
                          >Avez-vous du contenu dans votre bâtiment ?</label
                        >
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              :value="true"
                              v-model="
                                form.data.do_you_have_content_in_your_building
                              "
                              type="radio"
                              class="form-check-input"
                              name="content"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              :value="false"
                              v-model="
                                form.data.do_you_have_content_in_your_building
                              "
                              type="radio"
                              class="form-check-input"
                              name="content"
                            />Non
                          </label>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-md-12">
                        <h5>Matériel et mobilier</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7 col-12">
                        <label>Avez-vous du matériel et mobilier ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              :value="true"
                              v-model="
                                form.data.do_you_have_equipment_and_furniture
                              "
                              type="radio"
                              class="form-check-input"
                              name="materiel"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              :value="false"
                              v-model="
                                form.data.do_you_have_equipment_and_furniture
                              "
                              type="radio"
                              class="form-check-input"
                              name="materiel"
                            />Non
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label
                            >Prière fournir la liste détaillée des matériels et
                            mobiliers</label
                          >
                          <textarea
                            v-model="
                              form.data.detailed_list_of_equipment_and_furniture
                            "
                            class="form-control"
                          ></textarea>
                          <div
                            v-if="
                              errors.detailed_list_of_equipment_and_furniture
                            "
                            style="color: red"
                          >
                            {{
                              errors.detailed_list_of_equipment_and_furniture[0]
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Montant</label>
                          <input
                            v-model="form.data.amount_equipment_and_furniture"
                            type="number"
                            class="form-control"
                          />
                          <div
                            v-if="errors.amount_equipment_and_furniture"
                            style="color: red"
                          >
                            {{ errors.amount_equipment_and_furniture[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />

                    <div class="row">
                      <div class="col-md-12">
                        <h5>Effets personnels</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7 col-12">
                        <label>Avez-vous des effets personnels ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              :value="true"
                              v-model="form.data.personal_effects_in_building"
                              type="radio"
                              class="form-check-input"
                              name="personnal"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              :value="false"
                              v-model="form.data.personal_effects_in_building"
                              type="radio"
                              class="form-check-input"
                              name="personnal"
                            />Non
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label
                            >Prière fournir la liste détaillée des effets
                            personnels</label
                          >
                          <textarea
                            v-model="form.data.description_or_list_of_effects"
                            class="form-control"
                          ></textarea>
                          <div
                            v-if="errors.description_or_list_of_effects"
                            style="color: red"
                          >
                            {{ errors.description_or_list_of_effects[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Montant</label>
                          <input
                            v-model="form.data.personal_effects_amount"
                            type="number"
                            class="form-control"
                          />
                          <div
                            v-if="errors.personal_effects_amount"
                            style="color: red"
                          >
                            {{ errors.personal_effects_amount[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="row">
                      <div class="col-md-12">
                        <h5>Sécurité</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-7 col-12">
                        <label>Votre bâtiment est-il sécurisé ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              :value="true"
                              v-model="form.data.is_your_building_secure_bool"
                              type="radio"
                              class="form-check-input"
                              name="security"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              :value="false"
                              v-model="form.data.is_your_building_secure_bool"
                              type="radio"
                              class="form-check-input"
                              name="security"
                            />Non
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <label
                          >Précisez les dispositifs sécuritaire mis en
                          place</label
                        >
                        <v-select
                          v-model="form.data.is_your_building_secure"
                          taggable
                          multiple
                          label="title"
                          :options="devices"
                        />
                        <div
                          v-if="errors.is_your_building_secure"
                          style="color: red"
                        >
                          {{ errors.is_your_building_secure[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6 col-12">
                        <label>Avez-vous un animal domestique ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              :value="true"
                              v-model="form.data.do_you_have_pets"
                              type="radio"
                              class="form-check-input"
                              name="animal"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              :value="false"
                              v-model="form.data.do_you_have_pets"
                              type="radio"
                              class="form-check-input"
                              name="animal"
                            />Non
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>Combien ?</label>
                          <input
                            v-model="form.data.how_many_animals"
                            type="number"
                            min="0"
                            class="form-control"
                          />
                          <div
                            v-if="errors.how_many_animals"
                            style="color: red"
                          >
                            {{ errors.how_many_animals[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-6 col-12">
                        <label>Avez-vous déjà été victime d’un vol ?</label>
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              :value="true"
                              v-model="
                                form.data
                                  .have_you_ever_been_the_victim_of_a_theft
                              "
                              type="radio"
                              class="form-check-input"
                              name="vol"
                            />Oui
                          </label>
                          <label class="form-check-label ml-5">
                            <input
                              :value="false"
                              v-model="
                                form.data
                                  .have_you_ever_been_the_victim_of_a_theft
                              "
                              type="radio"
                              class="form-check-input"
                              name="vol"
                            />Non
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label>Date du vol</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <svg
                                  width="18"
                                  height="19"
                                  viewBox="0 0 18 19"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0)">
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M3.75 3.82251C3.33579 3.82251 3 4.1583 3 4.57251V15.0725C3 15.4867 3.33579 15.8225 3.75 15.8225H14.25C14.6642 15.8225 15 15.4867 15 15.0725V4.57251C15 4.1583 14.6642 3.82251 14.25 3.82251H3.75ZM1.5 4.57251C1.5 3.32987 2.50736 2.32251 3.75 2.32251H14.25C15.4926 2.32251 16.5 3.32987 16.5 4.57251V15.0725C16.5 16.3152 15.4926 17.3225 14.25 17.3225H3.75C2.50736 17.3225 1.5 16.3152 1.5 15.0725V4.57251Z"
                                      fill="#6E6B7B"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M12 0.82251C12.4142 0.82251 12.75 1.1583 12.75 1.57251V4.57251C12.75 4.98672 12.4142 5.32251 12 5.32251C11.5858 5.32251 11.25 4.98672 11.25 4.57251V1.57251C11.25 1.1583 11.5858 0.82251 12 0.82251Z"
                                      fill="#6E6B7B"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M6 0.82251C6.41421 0.82251 6.75 1.1583 6.75 1.57251V4.57251C6.75 4.98672 6.41421 5.32251 6 5.32251C5.58579 5.32251 5.25 4.98672 5.25 4.57251V1.57251C5.25 1.1583 5.58579 0.82251 6 0.82251Z"
                                      fill="#6E6B7B"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M1.5 7.57251C1.5 7.1583 1.83579 6.82251 2.25 6.82251H15.75C16.1642 6.82251 16.5 7.1583 16.5 7.57251C16.5 7.98672 16.1642 8.32251 15.75 8.32251H2.25C1.83579 8.32251 1.5 7.98672 1.5 7.57251Z"
                                      fill="#6E6B7B"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0">
                                      <rect
                                        width="18"
                                        height="18"
                                        fill="white"
                                        transform="translate(0 0.0725098)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                            </div>
                            <input
                              v-model="form.data.date_of_steal"
                              class="form-control"
                              type="date"
                            />
                          </div>
                          <div v-if="errors.date_of_steal" style="color: red">
                            {{ errors.date_of_steal[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label
                            >Prière préciser les circonstances du vol</label
                          >
                          <textarea
                            v-model="form.data.circumstances_of_steal"
                            type="text"
                            class="form-control"
                          ></textarea>
                          <div
                            v-if="errors.circumstances_of_steal"
                            style="color: red"
                          >
                            {{ errors.circumstances_of_steal[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div class="form-row">
                      <div class="col-12">
                        <div class="form-group">
                          <label>Autres informations complémentaires</label>
                          <textarea
                            v-model="form.data.other_additional_information"
                            type="text"
                            class="form-control"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="step === 2">
                    <p>Veuillez charger le(s) fichier(s) au besoin.</p>
                    <file-upload
                      ref="upload"
                      :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
                    />
                  </div>
                  <div v-if="step === 3">
                    <div class="detail__sup">
                      <div class="section__information">
                        <div class="section__information-text">
                          Prix de la souscription
                        </div>
                        <div class="section__information-dote"></div>
                        <div class="section__information-price">
                          {{
                            summary.total ? $format(summary.total) : 0 + " Fcfa"
                          }}
                        </div>
                      </div>
                      <div class="section__amount">
                        <div class="section__amount-text">Total</div>
                        <div class="section__amount-price">
                          {{
                            summary.total ? $format(summary.total) : 0 + " Fcfa"
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="section__neg" @click="saveNegotiated()">
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                          fill="#002A85"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                          fill="#002A85"
                        />
                        <path
                          d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 8.66732 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 5.90588C9.96089 5.90588 10.334 6.27898 10.334 6.73922Z"
                          fill="#002A85"
                        />
                      </svg>
                      <span class="section__neg-text"
                        >Demander une négociation</span
                      >
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="button__footer">
                    <button
                      @click="prevStep()"
                      :disabled="step === 1"
                      class="btn btn-default__cancel mr-2"
                    >
                      Retour
                    </button>
                    <button
                      class="btn btn-primary__save"
                      :class="loading ? 'disabled' : ''"
                      @click="saveAssurance()"
                    >
                      {{ getText() }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="payment__info">
      <div class="payment__info--text">Moyens de paiement acceptés</div>
      <div class="payment__widget">
        <img :src="$assets('images/payment.png')" width="140" alt="payment" />
      </div>
    </div>
    <div class="voyage__info">
      <div
        class="happy__young"
        :style="`background: url(${$assets(
          'images/young.png'
        )}) no-repeat center;background-size: cover;`"
      ></div>
      <div class="hire__me">
        <div class="background__info">
          <div class="svg__hire">
            <svg
              width="188"
              height="188"
              viewBox="0 0 188 188"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z"
                fill="#E8EFFF"
              />
            </svg>
          </div>
          <div class="hire__me--text">Contactez-nous</div>
          <div class="hire__me--description">
            Si vous avez des questions ou rencontrez une difficulté,
            contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
          </div>
          <div class="hire__me--button">
            <button class="btn btn-secondary">Parler à un expert</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { api } from "../../../../helpers/shared";
import FileUpload from "../../../../components/upload/FileUpload.vue";

export default {
  name: "habitation",
  components: { FileUpload },
  props: ["subscription"],
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    summary: {},
    errors: [],
    step: 1,
    element: 0,
    loading: false,
    files: [],
    form: {
      step: 1,
      amount: "",
      product_id: 2,
      data: {
        activity: "",
        content_value: "",
        building_value: "",
        name: "",
        email: "",
        address: "",
        phone: "",
        owner_of_the_building: true,
        building_tenant: false,
        living_space: "",
        year_of_construction_of_the_building: "",
        description_of_the_building: "",
        do_you_have_content_in_your_building: false,
        do_you_have_equipment_and_furniture: true,
        detailed_list_of_equipment_and_furniture: "",
        amount_equipment_and_furniture: "",
        personal_effects_in_building: true,
        description_or_list_of_effects: "",
        personal_effects_amount: "",
        is_your_building_secure_bool: true,
        is_your_building_secure: [],
        how_many_animals: "",
        have_you_ever_been_the_victim_of_a_theft: false,
        date_of_steal: "",
        circumstances_of_steal: "",
        equipment_or_furniture_in_building: false,
        description_or_list_of_equipment: "",
        value_of_equipment: "",
        do_you_have_pets: false,
        the_building_has_a_swimming_pool: false,
        subscription_period: "",
        other_additional_information: "",
      },
    },
    devices: [
      "Extincteurs",
      "Alarme",
      "RIA",
      "Gardien",
      "Barreaux ou Grilles Métaliques",
    ],
  }),
  mounted() {
    this.initializeForm(this.subscription);
  },
  methods: {
    initializeForm(element) {
      let { amount, data, product_id, step } = element;
      this.form.step = step;
      this.form.amount = amount;
      this.form.product_id = product_id;
      this.form.data = data;
    },
    addBasket() {
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                data.push({
                  product: this.form,
                  detail: this.summary,
                  files: this.files,
                  check: true,
                  uuids: this.$uuid(),
                  uuid: this.subscription.uuid,
                });
                //localStorage.setItem('carts', JSON.stringify(data));
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    files: this.files,
                    check: true,
                    uuids: this.$uuid(),
                    uuid: this.subscription.uuid,
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  window.location.href = "/pannier";
                }, 500);
              }
            } else this.$toasted.global.error();
          })
          .catch(() => {
            loader.hide();
            this.$toasted.global.error({
              message: "Impossible d'ajouter le produit au panier",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
            uuid: this.subscription.uuid,
          });
          //localStorage.setItem('carts', JSON.stringify(data));
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
              uuid: this.subscription.uuid,
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        }
      }
    },
    saveForLate() {
      if (
        Object.keys(this.summary).length === 0 &&
        this.summary.constructor === Object
      ) {
        this.$toasted.global.error({
          message: "Vous devez completer la première étape",
        });
      } else {
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/save-for-late"), this.form)
          .then((response) => {
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La souscription a été enrégistrée",
              });
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },

    saveNegotiated() {
      this.form.amount = this.summary.total;
      axios
        .post(
          api("subscription/negotiated/" + this.subscription.uuid),
          this.form
        )
        .then((response) => {
          if (response.data.status) {
            this.$toasted.global.all({
              message: "La demande de négociation a été enregistré",
            });
            setTimeout(() => {
              this.$router("/administration/subscriptions");
            }, 400);
          } else this.$toasted.global.error();
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          } else
            this.$toasted.global.error({
              message:
                "Vous devez vous connecter pour procéder à cette opération",
            });
        });
    },
    saveAssurance() {
      if (this.step === 3) {
        this.form.amount = this.summary.total;
        this.addBasket();
      } else {
        if (this.step === 1) {
          const loader = this.$loading.show({
            container: null,
            canCancel: false,
            color: "#4B4B4B",
            backgroundColor: "#4B4B4B",
            height: 35,
            width: 35,
            loader: "bars",
            opacity: 0.3,
          });
          this.loading = true;
          axios
            .post(api("assurances/habitation/save"), this.form)
            .then((response) => {
              this.loading = false;
              loader.hide();
              if (response.data.status) {
                this.summary = response.data.content;
                this.errors = [];
                this.nextStep();
              } else this.$toasted.global.error();
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
              }
              loader.hide();
              this.loading = false;
            });
        } else {
          this.nextStep();
        }
      }
    },
    nextStep() {
      if (this.step < 3) this.step++;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    prevStep() {
      if (this.step !== 1) this.step--;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    titleStep() {
      if (this.step === 1) {
        return "Informations";
      } else if (this.step === 2) {
        return "Fichiers joints";
      } else return "Résultat";
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
          break;
        case 2:
          return "Suivant";
          break;
        case 3:
          return "Ajouter au panier";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  margin-left: -16px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #e8f1ff;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  font-size: 14px;
}
.page__header--info {
  display: grid;
  height: 60px;
  margin-bottom: 10px;
  grid-template-columns: 3fr 1fr;
  .page__header--info__text {
    color: #001e5f;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: -0.3px;
    font-weight: bold;
    align-self: center;
  }
  .page__header--info__icon {
    place-self: center;
    cursor: pointer;
  }
}

.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 110px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}
.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg-text {
  color: #002a85;
}
.section__neg {
  cursor: pointer;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
</style>
